module.exports = __webpack_public_path__ + "static/media/brush-dental-health-healthy-life-svgrepo-com.d36800a4.svg";